/* tslint:disable */
/* eslint-disable */
/**
 * ReD Admin API Spec
 * ReD中途企業向けサイト用API
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: info@redesigner.jp
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { GetAccountSettings200ResponseSettingsInner } from './GetAccountSettings200ResponseSettingsInner';
import {
    GetAccountSettings200ResponseSettingsInnerFromJSON,
    GetAccountSettings200ResponseSettingsInnerFromJSONTyped,
    GetAccountSettings200ResponseSettingsInnerToJSON,
} from './GetAccountSettings200ResponseSettingsInner';

/**
 * 
 * @export
 * @interface GetAccountSettings200Response
 */
export interface GetAccountSettings200Response {
    /**
     * ステータス
     * @type {number}
     * @memberof GetAccountSettings200Response
     */
    status: number;
    /**
     * メッセージ
     * @type {string}
     * @memberof GetAccountSettings200Response
     */
    message: string;
    /**
     * 設定情報
     * @type {Array<GetAccountSettings200ResponseSettingsInner>}
     * @memberof GetAccountSettings200Response
     */
    settings?: Array<GetAccountSettings200ResponseSettingsInner>;
}

/**
 * Check if a given object implements the GetAccountSettings200Response interface.
 */
export function instanceOfGetAccountSettings200Response(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "status" in value;
    isInstance = isInstance && "message" in value;

    return isInstance;
}

export function GetAccountSettings200ResponseFromJSON(json: any): GetAccountSettings200Response {
    return GetAccountSettings200ResponseFromJSONTyped(json, false);
}

export function GetAccountSettings200ResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetAccountSettings200Response {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'status': json['status'],
        'message': json['message'],
        'settings': !exists(json, 'settings') ? undefined : ((json['settings'] as Array<any>).map(GetAccountSettings200ResponseSettingsInnerFromJSON)),
    };
}

export function GetAccountSettings200ResponseToJSON(value?: GetAccountSettings200Response | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'status': value.status,
        'message': value.message,
        'settings': value.settings === undefined ? undefined : ((value.settings as Array<any>).map(GetAccountSettings200ResponseSettingsInnerToJSON)),
    };
}

